// src/com/auto_plan_upload/AutoPlanUploadDict.js
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

// 자동배차 준비 정보, auto_plan_upload
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    // plan_date, store_id, left_over, tot_vol, n_bulk_pt, y_bulk_pt, o_bulk_pt, pbs_pt15, store_cpp, pre_pt17, day_pt04, day_pt11,  day_pt15, day_pt18, total_pt, nextday_04pt
    planDate : {
		id: 'planDate', label: '배차일자',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
        chech: IsValid.date
	}, // date
    storeId : {
		id: 'storeId', label: '점포코드',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
		check: (value) => {return IsValid.numericString(value, 2, 5)},
	}, // varchar(10)
    leftOver : {
		id: 'leftOver', label: '전날 남은PT',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= -999999 && value <= 999999},
	}, // int(11)
    totVol : {
		id: 'totVol', label: 'TOT_VOL',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
    nBulkPt : {
		id: 'nBulkPt', label: 'N BULK PT',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
    yBulkPt : {
		id: 'yBulkPt', label: 'Y BULK PT',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
    oBulkPt : {
		id: 'oBulkPt', label: 'O BULK PT',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
    pbsPt15 : {
		id: 'pbsPt15', label: 'PBS PT15',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
    storeCpp : {
		id: 'storeCpp', label: '점포별 CPP',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // double
    // 배차일자, 점포코드, 전날 남은PT, TOT_VOL, N BULK PT, Y BULK PT, O BULK PT, PBS PT15, 점포별 CPP, PREVIOUS17, 당일예상04, 당일예상11, 당일예상15, 당일예상18, 전체수량PT, 익일04예상PT
    prePt17 : {
		id: 'prePt17', label: 'PREVIOUS17',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
    dayPt04 : {
		id: 'dayPt04', label: '당일예상04',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
    dayPt11 : {
		id: 'dayPt11', label: '당일예상11',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
    dayPt15 : {
		id: 'dayPt15', label: '당일예상15',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
    dayPt18 : {
		id: 'dayPt18', label: '당일예상18',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
    totalPt : {
		id: 'totalPt', label: '전체수량PT',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
    nextday04Pt : {
		id: 'nextday04Pt', label: '익일04예상PT',
        type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 999999},
	}, // int(11)
};

/**
 * AUTO_PLAN_UPLOAD React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2025-03-17 11:29:50 using DbdbTap
 * https://www.dbdbtap.com
 */
export const AutoPlanUploadDictionary = {
    inputMap: Dict,
    /* errorTitle: {
        Add: '____ 등록 오류',
        Edit: '____ 수정 오류',
        Remove: '____ 삭제 오류',
        Get: '____ 조회 오류',
    }, */
    uploadTableProps: {
        tableId: 'autoPlanUploadTable',
        uniqueKey: 'storeId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            // csv data 보여주기.plan_date, store_id, left_over, tot_vol, n_bulk_pt, y_bulk_pt, o_bulk_pt, pbs_pt15, store_cpp, pre_pt17, day_pt04, day_pt11,  day_pt15, day_pt18, total_pt, nextday_04pt
            { id: 'ok', label: '상태', width: 50, show: true, option:{align: 'center', print:(r,i,v)=>v?'OK':<span style={{color:'red'}}>오류</span>} },
            { id: 'planDate', label: Dict.planDate.label, width: 90, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeId', label: Dict.storeId.label, width: 64, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'leftOver', label: Dict.leftOver.label, width: 86, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'totVol', label: Dict.totVol.label, width: 76, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'nBulkPt', label: Dict.nBulkPt.label, width: 90, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'yBulkPt', label: Dict.yBulkPt.label, width: 90, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'oBulkPt', label: Dict.oBulkPt.label, width: 90, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'pbsPt15', label: Dict.pbsPt15.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'storeCpp', label: Dict.storeCpp.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.FLOAT} },
            { id: 'prePt17', label: Dict.prePt17.label, width: 100, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'dayPt04', label: Dict.dayPt04.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'dayPt11', label: Dict.dayPt11.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'dayPt15', label: Dict.dayPt15.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'dayPt18', label: Dict.dayPt18.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'totalPt', label: Dict.totalPt.label, width: 80, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'nextday04Pt', label: Dict.nextday04Pt.label, width: 100, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            
            /* { id: 'arriveId', label: Dict.arriveId.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'restOverPt', label: Dict.restOverPt.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'updateDate', label: "updateDate", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'endBool', label: Dict.endBool.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.BOOLEAN} },
            { id: 'regDate', label: "regDate", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.DATETIME} },
            { id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'basicDockno', label: Dict.basicDockno.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'distanceOne', label: Dict.distanceOne.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'basicExpectRunTime', label: Dict.basicExpectRunTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'firstShipTime', label: Dict.firstShipTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'lastShipTime', label: Dict.lastShipTime.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'storeApplyCom', label: Dict.storeApplyCom.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'loadMaxCnt', label: Dict.loadMaxCnt.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'storeName', label: Dict.storeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'comName', label: Dict.comName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'vehTypeAlias', label: Dict.vehTypeAlias.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} }, */
        ]
    },
};
